import { Badge } from "@/components/ui/badge";
import { useTranslation } from "react-i18next";
import type { TimesheetStatus } from "@/lib/api";

const STYLES: Record<TimesheetStatus, string> = {
  "Draft": "bg-muted text-muted-foreground",
  "Submitted": "bg-blue-500/10 text-blue-600 dark:text-blue-400",
  "Approved": "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400",
  "Rejected": "bg-red-500/10 text-red-600 dark:text-red-400",
  "Needs Changes": "bg-amber-500/10 text-amber-600 dark:text-amber-400",
  "Locked": "bg-slate-500/10 text-slate-600 dark:text-slate-400",
};

const I18N_KEY: Record<TimesheetStatus, string> = {
  "Draft": "timekeeping.status.draft",
  "Submitted": "timekeeping.status.submitted",
  "Approved": "timekeeping.status.approved",
  "Rejected": "timekeeping.status.rejected",
  "Needs Changes": "timekeeping.status.needsChanges",
  "Locked": "timekeeping.status.locked",
};

export function TimesheetStatusBadge({ status }: { status: TimesheetStatus }) {
  const { t } = useTranslation();
  return (
    <Badge variant="secondary" className={`${STYLES[status]} border-0 font-medium`}>
      {t(I18N_KEY[status], { defaultValue: status })}
    </Badge>
  );
}
